import { Components, Theme } from '@mui/material';

export const MuiListSubheader: Components<Theme>['MuiListSubheader'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.primary,
    }),
  },
};
